
  import { Vue, Component } from "vue-property-decorator";
  import { getModule } from "vuex-module-decorators";
  import { Utils } from "@/helper";
  import { UserService } from "../services";
  import { Auth } from "@/store/modules/AuthModule";
  import store from "@/store";

  const AuthModule = getModule(Auth, store);

  @Component({
    name: "Login"
  })
  export default class Login extends Vue {
    publicPath: string = process.env.BASE_URL as string;
    showLoginForm: boolean = false;
    async created() {
      if (AuthModule.isAuthenticated) {
        this.$router.replace((this.$route.query as any).redirect || "/");
      } else {
        let response = await UserService.GetAuthenticationMethod();
        if (response.status === 200) {
          if (response.data === "VINSec") {
            this.showLoginForm = true;
          } else {
            this.showLoginForm = false;
          }
        }
      }
    }
    getImagePath(path: string) {
      return `${this.publicPath}${path}`;
    }
    async authorize() {
      this.$mainLoader.show();
      let response = await UserService.GetAuthorizeUrl();
      this.$mainLoader.hide();

      if (response.status === 200) {
        // window.location.replace(response.result)
        this.showAuthorizePopup(response.data);
      }
    }
    showAuthorizePopup(url: string) {
      Utils.ShowPopup(url, "VIN Login", 700, 500, "yes");
    }
    get greeting() {
      return Utils.Greeting(false);
    }
    get sunIcon() {
      return (
        this.greeting.endsWith("morning") || this.greeting.endsWith("afternoon")
      );
    }
  }
